<template>
  <div class="list-content">
    <div class="demo-query">
      <div class="demo-input-suffix">
        <span>关键词查询：</span>
        <el-input
          style="width: 300px"
          size="mini"
          placeholder="请输入地块名称"
          suffix-icon="el-icon-search"
          v-model="search.name"
        >
        </el-input>
        <!-- <span>产业类型：</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            style="width: 300px"
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="demo-button">
        <el-button
          size="mini"
          type="primary"
          style="background: #0065e9"
          icon="el-icon-map-location"
          @click="landDistribution"
          >地块分布</el-button
        >
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-search"
          @click="searchList"
          >查询</el-button
        >
        <el-button
          size="mini"
          type="info"
          icon="el-icon-delete"
          @click="clearSearch"
          >清除</el-button
        >
      </div>
    </div>
    <div class="list-main-content" v-loading="loading">
      <div
        style="cursor: pointer"
        v-for="(item, index) in landList"
        class="card-base"
        :key="index"
        v-show="landList.length"
        :style="index + 1 == 5 || index + 1 == 10 ? 'margin-right:0' : ''"
        @click="$router.push({ path: '/land/detail', query: { id: item.id } })"
      >
        <div>
          <div
            class="card-base-box"
            @click="
              $router.push({ path: '/land/detail', query: { id: item.id } })
            "
          >
            <!-- <img
              :src="
                item.imgUrl
                  ? item.imgUrl
                  : require('../../assets/images/home/land.png')
              "
              height="162px"
              width="245px"
              alt=""
            /> -->
            <img
              :src="
                item.pronounceImages && item.pronounceImages.length
                  ? imgSrc + item.pronounceImages[0].filePath
                  : require('../../assets/images/home/land.png')
              "
              alt=""
              height="162px"
              width="245px"
            />
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.industryTypeName"
            placement="bottom"
          >
            <div class="left-top" v-if="item.industryTypeName">
              {{ item.industryTypeName }}
            </div>
          </el-tooltip>

          <div class="right-top" v-if="item.parkName">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.parkName"
              placement="bottom-end"
            >
              <span>{{ item.parkName }}</span>
            </el-tooltip>
          </div>
          <div style="height: 90px">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.name || item.code"
              placement="bottom"
            >
              <span class="card-title">{{ item.name || item.code }}</span>
            </el-tooltip>

            <br />
            <div class="text-center">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.typeName"
                placement="bottom"
              >
                <el-tag class="card-info">{{ item.typeName }}</el-tag>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.countyName"
                placement="bottom"
              >
                <el-tag class="card-info mw-50" type="warning"
                  >{{ item.countyName }}
                </el-tag>
              </el-tooltip>
            </div>
            <div style="display: flex; align-items: center">
              <div
                :class="
                  item.supplyPeriod == 1
                    ? 'available'
                    : item.supplyPeriod == 3
                    ? 'availableNear'
                    : item.supplyPeriod == 4
                    ? 'availability'
                    : ''
                "
                class="park-detail-top-title3-li1 park-detail-top-title3-span1"
              >
                {{
                  item.supplyPeriod == 1
                    ? "立等可供"
                    : item.supplyPeriod == 3
                    ? "计划可供"
                    : item.supplyPeriod == 4
                    ? "规划可用"
                    : ""
                }}
              </div>
              <div
                class="dk-announcement"
                v-if="item.transferAnnounceStatus && item.transaction != '2'"
              >
                <span>已发布出让公告</span>
              </div>
            </div>
          </div>
          <div class="text-bottom">
            <!--价格-->
            <div class="price">
              <span class="iconfont icon-mianji"></span>
              <span style="padding-left: 5px"
                >{{ item.area }}
                <span style="font-size: 12px">亩</span>
              </span>
            </div>

            <!--展示浏览量-->
            <el-tooltip placement="right" :open-delay="1000">
              <div slot="content">
                浏览量：{{ item.statistical | filter_statistical }}
              </div>
              <div class="pageView">
                <browse :statistical="item.statistical"></browse>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div
          v-if="item.transaction == 2"
          :class="['card-mask', item.transaction == 2 ? 'yjy-color' : '']"
          @click="
            $router.push({ path: '/land/detail', query: { id: item.id } })
          "
        >
          {{ item.transaction == 2 ? "已成交" : "" }}
        </div>
        <div
          v-if="
            item.approvalStatus != 3 &&
            item.approvalStatus != 4 &&
            item.transaction != 2
          "
          :class="[
            'card-mask',
            item.approvalStatus != 3 &&
            item.approvalStatus != 4 &&
            item.transaction != 2
              ? 'dfb-color'
              : '',
          ]"
          @click="
            $router.push({ path: '/land/detail', query: { id: item.id } })
          "
        >
          {{
            item.approvalStatus != 3 &&
            item.approvalStatus != 4 &&
            item.transaction != 2
              ? "待发布"
              : ""
          }}
        </div>
        <div
          v-if="item.approvalStatus == 4 && item.transaction != 2"
          :class="[
            'card-mask',
            item.approvalStatus == 4 && item.transaction != 2
              ? 'wjy-color'
              : '',
          ]"
          @click="
            $router.push({ path: '/land/detail', query: { id: item.id } })
          "
        >
          {{
            item.approvalStatus == 4 && item.transaction != 2 ? "已下架" : ""
          }}
        </div>
      </div>
      <!-- <div
        class="list-main-item"
        v-for="(item, index) in landList"
        :key="index"
        @click="$router.push({ path: '/land/detail', query: { id: item.id } })"
        :style="{ marginRight: (index + 1) % 5 == 0 ? '0px' : '14px' }"
      >
        <div class="list-main-img">
          <img
            v-if="item.pronounceImages && item.pronounceImages.length"
            :src="imgSrc + item.pronounceImages[0].filePath"
            alt=""
          />
        </div>
        <div class="list-main">
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.name || item.code"
            :open-delay="100"
            placement="bottom"
          >
            <div class="list-main-title">{{ item.name || item.code }}</div>
          </el-tooltip>
          <div class="list-main-seat">
            <span class="list-main-seat-title">位置：</span>
            <span class="list-main-seat-detail">{{ item.location }}</span>
          </div>
          <div class="list-main-seat">
            <span class="list-main-seat-title">容积率：</span>
            <span class="list-main-seat-detail">{{ item.plotRate }}</span>
          </div>
          <div class="list-main-seat">
            <span class="list-main-seat-title">建筑密度：</span>
            <span class="list-main-seat-detail">{{
              item.buildingDensity
            }}</span>
          </div>
          <div class="list-main-seat">
            <span class="list-main-seat-title">绿地率：</span>
            <span class="list-main-seat-detail">{{ item.greeningRate }}</span>
          </div>
          <div class="list-main-seat-bottom">
            <div class="list-main-bottom">
              <span class="list-main-price">{{ item.area }}</span>
              <span class="list-main-unit">亩</span>
            </div>
          </div>
        </div>
        <img
          v-if="item.typeName === '住宅用地' || item.typeName === '商服用地'"
          class="position-img"
          :src="require('@/assets/promotion/bz01.png')"
          alt=""
        />

        <span class="transform-size">{{ item.typeName }}</span>
      </div> -->
      <div class="park-list-table-no-c-img" v-if="!landList.length">
        <img src="../../assets/images/common/1.png" alt="" />
      </div>
    </div>
    <!--分页-->
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="search.current"
        :page-size.sync="search.size"
        :page-sizes="[6, 12, 24, 30]"
        prev-text="上一页"
        next-text="下一页"
        layout=" prev, pager, next, total, jumper "
        :total="total"
        style="background-color: #ecf5ff"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="地块分布"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div style="height: 550px">
        <tz-map
          ref="map"
          :position="position"
          container="mapView"
          :zoom="8"
          mw="100%"
          mh="100%"
          :maxZoom="18"
        >
          <tz-toggle-map :base-list="configList" :is-note="true" :index="1" />
          <mapImage></mapImage>
          <!-- 图例 -->

          <div class="map-tl">
            <div class="map-tl-title">图例</div>
            <div
              class="key-content"
              v-for="(item, index) in examplesData"
              :key="index"
            >
              <img class="key-img" v-if="levels <= 13" :src="item.bgc" alt="" />
              <div
                class="key-img1"
                v-if="levels > 13"
                :style="{ background: item.bgc2 }"
              ></div>
              <span class="key-text">{{ item.name }}</span>
            </div>
          </div>
        </tz-map>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInnerParcelList,
  getPromotionParcel,
  getPromotionScope,
  getParkCodeShp,
} from "@/api/setting/investment";
import { getCountyShp } from "@/api/common";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom.js";
import Browse from "@/components/currency/browse";
import Concert from "@/map/Convert";
import mapImage from "@/components/mapImage";
export default {
  name: "listMain",
  components: { Browse, mapImage },
  props: ["areaCheckList", "editId", "outerId", "parkCode", "countyCode"],
  data() {
    return {
      dialogVisible: false, //地块分布
      position: [100.264162, 25.615269],
      input: "",
      options: [],
      value: "",
      page: 1,
      rows: 9,
      total: 24,
      listData: [],
      search: {
        current: 1,
        name: "",
        outerId: "",
        size: 10,
        tjzcId: null,
      },
      landList: [],
      total: 0,
      imgSrc: systemConfig.imgServer + systemConfig.imgApi,
      loading: false,
      mapView: null,
      configList: mapConfig.configList,
      spotList: [], //点数据
      examplesData: [
        {
          name: "立等可供",
          bgc: require("@/assets/images/tl1.png"),
          bgc2: "#02D64A",
          bgc1: "#02d64a80",
        },
        {
          name: "计划可供",
          bgc: require("@/assets/images/tl3.png"),
          bgc2: "#497AFF",
          bgc1: "#497aff80",
        },
      ],
      levels: 8,
    };
  },
  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  watch: {
    editId: {
      handler(val) {
        if (val) {
          this.getList();
        }
      },
      immediate: true,
      deep: true,
    },
    outerId: {
      handler(newVal) {
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.concert = new Concert();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    //地块分布
    landDistribution() {
      this.dialogVisible = true;
      let that = this;
      this.$nextTick(() => {
        that.mapView = that.$refs.map.tzApi;
        if (this.parkCode) {
          this.getParkShp();
        }
        if (this.countyCode && !this.parkCode) {
          this.getCountyShps();
        }
        that.spotDistribution();
        that.mapView.addMoveendCallBack(function (res) {
          let zoomObj = that.mapView.getZoomInfo();
          let level = Math.round(zoomObj.zoom);
          that.levels = level;
          if (level <= 13) {
            that.spotDistribution();
          } else {
            that.scopeDistribution();
          }
        });
      });
    },
    //园区范围
    getParkShp() {
      getParkCodeShp(this.parkCode).then((res) => {
        if (res.data.success) {
          let data = res.data.data;

          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["fromDataName", "lng", "lat"],
            4490
          );
          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "parkLayer",
            99,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              return that.mapView.setPolygonStyle(
                properties.fromDataName,
                "#aaeb13",
                "rgba(0,0,0,0)",
                undefined,
                undefined,
                undefined,
                undefined,
                4
              );
            }
          );
          that.mapView.zoomToExtentByLayerId("parkLayer");
        }
      });
    },
    //行政区划范围
    getCountyShps() {
      getCountyShp({ county: this.countyCode }).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let extent = this.mapView.getMultiPolygonExtent(
            data.geom.coordinates
          );
          this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]); //居中地图范围
        }
      });
    },
    //面分布
    scopeDistribution() {
      this.mapView.removeLayer("landPointLayerId");
      console.log("-----------");
      let data = this.mapView.getViewExtent(); //获取视图范围
      let scope = [
        [data[0], data[3]],
        [data[2], data[3]],
        [data[2], data[1]],
        [data[0], data[1]],
        [data[0], data[3]],
      ];
      let obj = {
        scope: {
          type: "MultiPolygon",
          coordinates: [[scope]],
        },
        tjzcId: this.editId,
      };
      getPromotionScope(obj).then((res) => {
        if (res.data.success) {
          if (this.levels <= 13) {
            return false;
          }
          let data = res.data.data;
          this.mapView.removeLayer("landLayerId"); //先清除再渲染
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            ["name", "parcelId", "supplyPeriod", "lng", "lat"],
            4490
          );
          this.mapView.addGeojsonMapLayer(
            geojson,
            "landLayerId",
            101,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let id = "chunkId_" + properties.parcelId;
              let fillColor =
                properties.supplyPeriod == 1
                  ? this.examplesData[0].bgc1
                  : properties.supplyPeriod == 3
                  ? this.examplesData[1].bgc1
                  : ""; //填充色
              let center = [properties.lng, properties.lat];
              feature.setProperties({
                id: id,
                center: center,
                fillColor: fillColor,
              });
              return this.mapView.setPolygonStyle(
                properties.name,
                "rgba(0,0,0,0)",
                fillColor,
                "#fff"
              );
            }
          );
        }
      });
    },
    //点分布
    spotDistribution() {
      getPromotionParcel(this.editId).then((res) => {
        if (res.data.success) {
          //预防数据还未请求成功，地图层级已变化到不需要画点的情况
          if (this.levels > 13) {
            return false;
          }
          this.spotList = res.data.data;
          let geojson = this.concert.toGeoJson(
            this.spotList,
            "geom",
            ["name", "parcelId", "supplyPeriod", "lng", "lat"],
            4490
          );
          let that = this;
          this.mapView.addGeojsonMapLayer(
            geojson,
            "landPointLayerId",
            100,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let id = "marker_" + properties.parcelId;
              let fillColor =
                properties.supplyPeriod == 1
                  ? that.examplesData[0].bgc1
                  : properties.supplyPeriod == 3
                  ? that.examplesData[1].bgc1
                  : ""; //填充色
              let center = [properties.lng, properties.lat];
              let imgUrl =
                properties.supplyPeriod == 1
                  ? that.examplesData[0].bgc
                  : properties.supplyPeriod == 3
                  ? that.examplesData[1].bgc
                  : require("@/assets/leadCockpitImage/land.png");
              feature.setProperties({
                id: id,
                center: center,
                fillColor: fillColor,
              });
              let style = that.mapView.setPointStyle("", imgUrl, 1);
              return style;
            }
          );
        }
      });
    },

    getList() {
      this.search.tjzcId = this.editId ? this.editId : "";
      this.search.outerId = this.outerId ? this.outerId : "";
      this.loading = true;
      getInnerParcelList(this.search).then((res) => {
        if (res.data.success) {
          this.landList = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    searchList() {
      this.search.current = 1;
      this.getList();
    },
    clearSearch() {
      this.search.name = "";
      this.search.current = 1;
      this.getList();
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      this.search.size = newSize;
      this.getList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.search.current = newPage;
      this.getList();
    },
    // 设置当前页面数据，对数组操作的截取规则为[0~10],[10~20]...,
    setCurrentPageData() {
      let begin = (this.page - 1) * this.rows;
      let end = this.page * this.rows;
      this.currentPageData = this.listData.slice(begin, end);
    },
  },
};
</script>

<style scoped>
.list-content {
  width: 60%;
  margin: 40px auto 40px auto;
}
.demo-query {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.demo-input-suffix {
  display: flex;
  align-items: center;
}
.demo-button {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.demo-input-suffix span {
  white-space: nowrap;
  margin-left: 10px;
  font-size: 16px;
  color: #696969;
}
.list-main-content {
  /*width: 60%;*/
  margin: auto;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  border-radius: 4px;
  flex-wrap: wrap;
  min-height: 200px;
}
.list-main-item {
  position: relative;
  width: calc(100% / 5 - 12px);
  /* margin-left: 20px; */
  box-shadow: inset 0 0 5px rgb(63 77 201 / 10%), 0 0 4px rgb(140 141 140 / 60%);
  margin-top: 20px;
}
.park-list-table-no-c-img {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}

.park-list-table-no-c-img > img {
  width: 30%;
}
.transform-size {
  display: block;
  position: absolute;
  right: 10px;
  bottom: 25px;
  font-size: 12px;
  transform: rotate(-45deg);
  color: #ffffff;
}
.position-img {
  position: absolute;
  right: -5px;
  bottom: -4px;
  width: 90px;
}
/* .list-main-item:nth-child(3n + 1) {
  margin-left: 0;
} */
.list-main {
  padding: 20px;
}
.list-main-img {
  height: 160px;
  background: linear-gradient(
    160deg,
    rgba(63, 77, 201, 0.8),
    rgba(102, 180, 213, 0.4)
  );
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.list-main-img > img {
  width: 100%;
  height: 100%;
}
.list-main-title {
  font-weight: bold;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-main-seat {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.list-main-seat-title {
  color: #3a6fd6;
  font-size: 14px;
}
.list-main-seat-detail {
  font-size: 14px;
  color: #939393;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.list-main-seat-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.list-main-bottom {
  margin-top: 10px;
  color: #333333;
}
.list-main-price {
  font-size: 18px;
  font-weight: bold;
}
.list-main-unit {
  font-size: 14px;
  margin-left: 5px;
}
.qr-code {
  width: 30px;
  height: 30px;
  background: #e5e5e5;
}
.page-box {
  display: flex;
  padding: 50px 0;
  background: #ffffff;
  justify-content: center;
  align-items: center;
}
/deep/ .el-pagination button:disabled {
  background: #386ed6;
  color: #ffffff;
  border-radius: 2px;
}
/deep/ .el-pagination {
  background: #ffffff !important;
}
/deep/ .el-pager li.active {
  border: none;
  border-radius: 0;
  background: #386ed6;
  color: #ffffff;
}
/deep/ .el-pager li {
  border: 1px solid #386ed6;
  color: #386ed6;
  margin-right: 10px;
}
/deep/ .el-pager li:nth-child(1) {
  margin-left: 10px;
}
/deep/ .el-pager li.active + li {
  border: 1px solid #386ed6;
}
/deep/ .el-dialog__body {
  padding: 0 20px 30px;
}
.map-tl {
  position: absolute;
  bottom: 100px;
  right: 10px;
  background: #fff;
  box-shadow: 0 0 10px #d3d2d2;
  padding-bottom: 10px;
  border: 1px solid #6ab8fe;
  border-radius: 4px;
  z-index: 999;
}
.map-tl-title {
  text-align: center;
  padding: 5px 0;
  font-size: 14px;
}
.key-text {
  margin-left: 5px;
  color: #787676;
  font-size: 12px;
}
.key-content {
  padding: 0 10px;
  margin-top: 5px;
  display: flex;
  align-items: center;
}

.key-content:nth-child(1) {
  margin-top: 0;
}

.map-tl-li {
  display: flex;
  font-size: 12px;
  padding: 3px 10px;
}

.map-tl-li-span {
  padding-left: 5px;
  color: #787676;
}
.key-img1 {
  width: 20px;
  height: 10px;
}

.key-img {
  width: 20px;
}

.card-base {
  display: inline-block;
  position: relative;
  width: calc((100% - 80px) / 5);
  box-shadow: 0 0 4px #c7c3c3;
  margin-top: 15px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 15px;
  /*height: 267px;*/
}

.card-mask {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 162px;
  width: 100%;
  /* background: #b2b7b98c; */
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
}

.yjy-color {
  background: rgba(187, 253, 196, 0.4);
  /* color: rgb(10, 207, 116); */
  color: rgb(0, 114, 62);
}
.dfb-color {
  background: rgb(103, 168, 251, 0.4);
  color: rgb(5, 102, 173);
}
.wjy-color {
  /* color: rgb(255, 89, 132); */
  color: rgb(209, 0, 54);
  background: rgba(255, 179, 199, 0.4);
}

/* 新卡片样式 */
.card-base-box {
  cursor: pointer;
  width: 100%;
}

.card-base-box > img {
  width: 100%;
}

.card-title {
  margin: 2px 5px;
  font-size: 17px;
  font-weight: bold;
  display: inline-block;
  width: calc(100% - 10px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pageView {
  width: 80px;
  /*position: absolute;*/
  /*right: 16px;*/
  text-align: right;
  /*top: 2px;*/
  cursor: pointer;
}

.color-4 {
  color: red;
}

.color-1 {
  color: #f4420a;
}

.color-2 {
  color: #ff6941;
}

.color-3 {
  color: #ff9001;
}
.need-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 27px;
}

.need-area-slider {
  display: inline-block;
  width: 100px;
  margin: 0 5px;
}

.need-area-input {
  width: 100px;
  display: inline-block;
  padding: 0 8px;
}

.left-top {
  max-width: 80px;
  line-height: 20px;
  height: 20px;
  position: absolute;
  left: 10px;
  top: 10px;
  background: #e56810;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left-top span {
}

.right-top {
  width: 50px;
  height: 16px;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
}

.right-bottom {
  position: absolute;
  right: 10px;
  top: 135px;
  padding: 2px 6px;
  background: #00000059;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
}

.right-top span {
  display: block;
  color: white;
  width: 50px;
  height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-bottom {
  height: 30px;
  /*position: relative;*/
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.text-center {
  /*height: 20px;*/
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.mw-50 {
  margin-left: 5px;
  max-width: 115px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-bottom .price {
  /*position: absolute;*/
  /*left: 12px;*/
  /*top: 2px;*/
}

.text-bottom .price span {
  font-weight: bold;
}

.title-select {
  border: 1px solid #bfbfbf;
  padding: 20px 10px;
}

.tool-title {
  color: #979797;
  margin-top: 10px;
  display: inline-block;
}

.content {
  /*position: relative;*/
}

.input-box {
  position: absolute;
  top: 43px;
  left: 105px;
  background: #fff;
  /* border: 1px solid #e4e7ed; */
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 99999;
}

.input-box > div {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  font-size: 13px;
  cursor: pointer;
}

.content span {
  color: #7c7c7c;
  display: inline-block;
  margin: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
}

.content span:hover {
  color: #58aec3;
}

.content .span-active {
  color: #1bbafd;
}

.content2 {
  margin-top: 10px;
}

.content2 span {
  font-weight: unset;
}

.bottom-line-dashed {
  border-bottom: 1px dashed #b5b5b5;
  position: relative;
}

.shrink {
  overflow: hidden;
  /* height: 88px; */
  height: 44px;
  /*position: relative;*/
}

.shrink-child {
  height: 0;
}

.more {
  position: absolute;
  right: 0px;
  top: 10px;
  font-size: 15px;
  color: #00d2fd;
  cursor: pointer;
}

.shrink-btn {
  position: absolute;
  right: 0px;
  bottom: 10px;
  font-size: 15px;
  color: #00d2fd;
  cursor: pointer;
}

.search-button {
  height: 28px;
  margin-left: 20px;
  line-height: 28px;
  padding: 0 20px;
  border-radius: 4px;
  font-weight: normal;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
}

.search-button:hover {
  /*opacity: 0.5;*/
}

.search-button-bgc1 {
  background: #18a7e9;
}

.search-button-bgc2 {
  background: #f5a702;
}

.search-button-bgc3 {
  background: #00baaf;
}

.select-bgc {
  /*opacity: 0.5;*/
  background: #409eff;
  color: #fff;
  border: none;
  /*font-weight: bold;*/
}

.develop {
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
}

.availableNear {
  background: rgb(73, 122, 255);
}

.available {
  background: rgb(2, 214, 74);
}

.availability {
  background: rgb(255, 174, 17);
}

.park-detail-top-title3-li1 {
  border-radius: 4px;
  /*background: #ff4c4c;*/
  color: #fff;
  text-align: center;
}

.park-detail-top-title3-span1 {
  text-align: center;
  align-items: center;
  font-size: 14px;
  width: 70px;
  /*padding: 0 10px;*/
  height: 25px;
  /*font-weight: 600;*/
  /*padding: 5px;*/
  line-height: 28px;
  display: flex;
  justify-content: center;
  /*margin: 10px 5px;*/
  margin-left: 5px;
  margin-top: 5px;
}

.el-tag--mini {
  height: 25px;
  line-height: 25px;
  margin-top: 5px;
}

.intention {
  background-color: transparent;
}

.dk-announcement {
  width: 100%;
  height: 25px;
  color: #fff;
  background: #f98e48;
  line-height: 25px;
  font-size: 14px;
  width: max-content;
  margin: 5px 0 0 5px;
  border-radius: 4px;
  padding: 0 5px;
}
.dk-announcement img {
  width: 16px;
  height: 16px;
}

.transfer-announce-status {
  margin-left: 15px;
  font-size: 14px;
  color: #303133;
  font-weight: normal;
}
</style>


</style>